module.exports = __webpack_public_path__ + "img/pingsheng-status01.d1b1fc8b.png";